// extracted by mini-css-extract-plugin
var _1 = "RecipientsField-modulefield__YxK5O";
export { _1 as "field" }
